import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    info(text = '') {
        toast.info(text, {
            autoClose: 5000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.TOP_CENTER,
            theme: "colored",
        });
    },
    success(text = '') {
        toast.success(text, {
            autoClose: 5000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.TOP_CENTER,
            theme: "colored",
        });
    },
    warning(text = '') {
        toast.warning(text, {
            autoClose: 5000,
            dangerouslyHTMLString: true,
            position: toast.POSITION.TOP_CENTER,
            theme: "colored",
        });
    },
    error(text = '') {
        toast.error(text, {
            autoClose: false,
            dangerouslyHTMLString: true,
            // icon: "❌",
            position: toast.POSITION.TOP_CENTER,
            theme: "colored",
        });
    }
}
